
export default (props) => (
    <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 60 60"
        width={props.size ?? 24}
        height={props.size ?? 24}
        fill="currentColor"
        stroke="none"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        className={props.className}
    >

        <g transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
             stroke="none">
            <path d="M300 580 c0 -6 -11 -15 -25 -20 -27 -10 -30 -20 -16 -48 5 -9 12 -24
14 -33 4 -12 17 -16 47 -16 30 0 43 4 47 16 2 9 9 24 14 33 14 28 11 38 -16
48 -14 5 -25 14 -25 20 0 5 -9 10 -20 10 -11 0 -20 -5 -20 -10z m45 -34 c15
-8 22 -17 16 -21 -6 -3 -11 -14 -11 -23 0 -12 -8 -17 -30 -17 -22 0 -30 5 -30
17 0 9 -5 20 -11 24 -7 4 -2 11 13 19 12 7 24 13 24 14 1 1 14 -5 29 -13z"/>
            <path d="M119 503 c-9 -10 -24 -23 -34 -28 -15 -9 -16 -14 -5 -35 7 -14 16
-31 20 -39 3 -8 22 -15 45 -15 32 -1 40 3 43 19 2 11 8 30 14 42 6 13 9 24 7
26 -2 1 -18 12 -36 25 -39 26 -35 26 -54 5z m45 -28 c20 -14 22 -19 13 -39 -8
-16 -20 -23 -39 -23 -20 0 -27 5 -24 13 3 8 1 16 -4 19 -15 9 -12 25 5 25 8 0
15 5 15 10 0 14 7 13 34 -5z"/>
            <path d="M472 500 c-12 -10 -28 -20 -35 -23 -9 -3 -9 -9 1 -26 6 -11 12 -30
12 -41 0 -16 7 -20 35 -20 19 0 38 -1 41 -2 4 -2 10 4 14 12 4 8 13 26 20 40
11 21 10 26 -5 35 -10 5 -25 18 -34 28 -19 21 -21 21 -49 -3z m38 -20 c0 -5 7
-10 15 -10 17 0 20 -16 5 -25 -5 -3 -7 -11 -4 -19 3 -8 -4 -13 -24 -13 -40 0
-59 40 -28 61 25 18 36 20 36 6z"/>
            <path d="M261 414 c-31 -39 -29 -107 4 -139 55 -55 135 -15 135 68 0 62 -29
97 -80 97 -30 0 -43 -6 -59 -26z m87 -11 c-4 -22 -69 -56 -82 -43 -5 5 -3 19
8 34 20 32 80 38 74 9z m30 -77 c2 -3 -3 -17 -12 -31 -21 -33 -68 -34 -90 -3
-21 30 -20 36 7 41 25 6 87 1 95 -7z"/>
            <path d="M211 216 c-7 -9 -11 -42 -9 -88 l3 -73 115 0 115 0 3 73 c2 46 -2 79
-9 88 -8 10 -37 14 -109 14 -72 0 -101 -4 -109 -14z m49 -24 c0 -10 6 -41 14
-70 l13 -52 -33 0 -34 0 0 63 c0 35 3 67 7 70 13 13 33 7 33 -11z m158 -55 l3
-67 -31 0 c-33 0 -34 4 -19 70 14 64 18 72 32 68 7 -3 13 -29 15 -71z m-84 2
c11 -54 8 -69 -14 -69 -22 0 -25 15 -14 69 4 17 10 31 14 31 4 0 10 -14 14
-31z"/>
        </g>
    </svg>
);
